import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PreSales1ModalComponent } from '../pre-sales1-modal/pre-sales1-modal.component';
import { UserService } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { AfterSales1ModalComponent } from '../after-sales1-modal/after-sales1-modal.component';

@Component({
  selector: 'app-choice-process-modal',
  templateUrl: './choice-process-modal.component.html',
  styleUrls: ['./choice-process-modal.component.scss'],
})
export class ChoiceProcessModalComponent implements OnInit {
  constructor(
    private modal: MatDialog,
    private modalRef: MatDialogRef<ChoiceProcessModalComponent>,
    private user: UserService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getSelf();
  }

  openPreSales1Modal() {
    this.modalRef.close();
    this.modal.open(PreSales1ModalComponent, {
      width: '712px',
    });
  }

  self: any = null;
  async getSelf() {
    try {
      this.self = await this.user.getSelf();
    } catch (error) {}
  }

  openAfterSales1Modal() {
    if (!this.self) {
      this.router.navigateByUrl('/login');
      return;
    }
    this.modalRef.close();
    this.modal.open(AfterSales1ModalComponent, {
      width: '612px',
    });
  }
}
